import PropTypes from 'prop-types'
import React, { Component } from 'react'
import throttle from 'lodash.throttle'
import classnames from 'classnames'

import { getElementOffset } from '../../utils/dom'

class AnimatedNumber extends Component {
  constructor () {
    super()
    this.state = {
      currentNumber: 0,
      hasAnimated: false,
      precision: 0
    }
    this.start = this._start.bind(this)
    this.increment = this._increment.bind(this)
    this.stop = this._stop.bind(this)
    this._handleScroll = this._handleScroll.bind(this)
  }
  componentDidMount () {
    const { finalNumber, startOnMount, startOnMountDelay } = this.props
    // precision
    const precision = Number.isInteger(finalNumber)
      ? 0
      : String(finalNumber)
        .split('.')
        .slice(-1)[0].length

    if (startOnMount) {
      setTimeout(() => {
        this._start()
      }, startOnMountDelay || 0)
      return
    }

    // trigger when it is 100% inside the screen - i.e. at the bottom of the screen
    this._yCoordStart =
      getElementOffset(this._spanElement).top - // position when top of element is at top of screen
      (window.innerHeight - this._spanElement.getBoundingClientRect().height)
    // setState
    this.setState({
      currentNumber: 0,
      precision
    })
    // scroll listener
    this._throttledScroll = throttle(this._handleScroll, 60)
    window.addEventListener('scroll', this._throttledScroll)
  }
  _start () {
    const { finalNumber, animationTime } = this.props
    if (animationTime > 0) {
      const stepTime = animationTime / 45
      this._dx = finalNumber / parseFloat(stepTime)
      this.incrementInterval = setInterval(this.increment, stepTime)
    }
  }
  _increment () {
    const { _dx } = this
    const { finalNumber } = this.props
    const { currentNumber } = this.state
    let newNumber = currentNumber + _dx
    if (newNumber >= finalNumber) {
      this.stop()
      newNumber = finalNumber
    }
    this.setState({ currentNumber: newNumber })
  }
  _stop () {
    clearInterval(this.incrementInterval)
    window.removeEventListener('scroll', this._throttledScroll)
  }
  _handleScroll () {
    const { _yCoordStart } = this
    const { hasAnimated } = this.state
    if (!hasAnimated && _yCoordStart < window.pageYOffset) {
      this.start()
      this.setState({ hasAnimated: true })
    }
  }
  componentWillUnMount () {
    this.stop()
  }
  render () {
    const { className, finalNumber } = this.props
    const { currentNumber, precision } = this.state
    const displayNumber =
      typeof document === 'undefined'
        ? finalNumber
        : currentNumber
          .toFixed(precision)
        // from http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    const classes = classnames(
      {
        [className]: !!className
      },
      'animated-number'
    )

    return (
      <span
        className={classes}
        ref={element => {
          this._spanElement = element
        }}
      >
        {displayNumber}
      </span>
    )
  }
}

AnimatedNumber.propTypes = {
  finalNumber: PropTypes.number,
  animationTime: PropTypes.number,
  className: PropTypes.string,
  startOnMount: PropTypes.bool
}

AnimatedNumber.defaultProps = {
  animationTime: 1200
}
export default AnimatedNumber



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/AnimatedNumber.js